import '../../scss/talk-show.scss';

require('../common/share');
import '../common/slider';
